import { Form } from './styles'

export default Form